<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <div class="card card-default">
          <div class="card-header">
            <h5>{{ $t('JSON.what-would-you-like-to-do') }}</h5>
          </div>

          <div class="card-body">
            <div
              v-for="(modal, key) in modals"
              :key="key"
            >
              <b-button
                variant="primary"
                @click="toggleModal(`${key}`)"
              >
                {{ _.startCase(_.camelCase(modal.text)) }}
                <b-badge variant="light">
                  {{ modal.shortcut }}
                </b-badge>
              </b-button>
              <br><br>
            </div>
          </div>
        </div>
      </div>
    </MadModal>
  </div>
</template>

<script>
/* eslint-disable consistent-return */

import Keypress from 'keypress.js';
import permissions from '@/mixins/permissions';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
  },
  mixins: [permissions],

  data() {
    return {
      opened: false,
      listener: null,
      timeout: null,
    };
  },

  computed: {
    modalId() {
      return 'monitor';
    },

    _() {
      return _;
    },

    modals() {
      return {
        post: {
          text: this.$i18n.t('JSON.manage-posts'),
          shortcut: 'p',
        },
      };
    },
  },

  created() {
    this.setupKeyboardListeners();
  },

  beforeDestroy() {
    this.listener.reset();
  },

  methods: {
    toggleModal(modalId) {
      // console.log(`toggling modal ${modalId}`);
      if (this.isLoggedIn()) {
        Bus.$emit('toggle_modal', modalId, null);
      }
    },

    onOpened() {
      this.opened = true;
    },

    onClosed() {
      this.opened = false;
    },

    setupKeyboardListeners() {
      this.listener = new Keypress.Listener();

      // console.log(this.modals);

      Object.keys(this.modals).forEach((key) => {
        // console.log(key, this.modals[key]);

        this.listener.simple_combo(this.modals[key].shortcut, (event) => {
          // console.log(`pressed ${this.modals[key].shortcut}`);
          if ((event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') || !this.opened) {
            return true;
          }

          this.toggleModal(key);
        });
      });
    },
  },
};
</script>
